export default {
  titles: 'Polia na podpis',
  defaultHint: 'Správa zobrazuje tieto oddelenia vo svojom jazyku, kým ich nezmeníte.',
  titlePlaceholder: 'Názov poľa na podpis',
  addTitle: 'Pridať pole na podpis',
  titleTooLong: 'Zadajte najviac {maxLength} znakov.',
  restoreDefaults: 'Obnoviť predvolené',
  titleEmpty: 'Zadajte názov.',
  defaultDepartments: {
    material: 'Materiál',
    quality: 'Kvalita',
    engineering: 'Inžinierstvo',
    manufacturing: 'Výroba',
    program: 'Program',
    customer: 'Zákazník',
  },
};
